<div *ngIf="isBrowser" >
    <div class="col-sm-12">
        <div class="row" *ngIf="iframeSource">
            <div class="col" style="font-weight:bold;">{{code}}</div>
            <div class="col" style="text-align: right;">
                <a title="{{code}} Hisse Genişlet" id="{{code}}_id" [href]="iframeSource" target="_blank" rel="noreferrer" [attr.aria-label]="code + ' Hisse Genişlet'">
                    <fa-icon [icon]="faExpand"></fa-icon>
                </a>
            </div>
        </div>
    </div>
    <div class="col-sm-12">
        <div class="row">
            <div class="col" style="font-weight:bold;" *ngIf="iframeSource">
                <iframe [src]='iframeSource' title="{{code}} Hisse Grafik" width="100%" height="500px"></iframe>
            </div>
            <div class="w-100"></div>
        </div>
    </div>
</div>
